import { motion } from 'motion/react'
import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.3fr;
  gap: 1px;
  background-color: ${props => props.theme.colors.border.default};
  border-radius: ${props => props.theme.primitives.radius.radius1};
  box-shadow: 0px 5px 16px 0px rgba(0, 60, 70, 0.12);

  & > div:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  & > div:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`

export const OverAllContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
  align-items: center;
  background-color: ${props => props.theme.colors.background.primary};
  cursor: pointer;
`

export const ChartTextContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`

export const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp24};
  width: 100%;
`

export const ProgressBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: ${props => props.theme.colors.disabled.surface};
  border-radius: ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius1}
    ${props => props.theme.primitives.radius.radius1} ${props => props.theme.primitives.radius.radius0};
  width: 100%;
  height: ${props => props.theme.size['3XS']};
  border-radius: ${props => props.theme.primitives.radius.radiusFull};
`

export const ProgressBarContent = styled(motion.div)`
  width: 0%;
  height: ${props => props.theme.size['3XS']};
  background: ${props => props.gradient};
  border-radius: ${props => props.theme.primitives.radius.radius1};
  transition: width 0.3s ease-in-out;
  border-radius: ${props => props.theme.primitives.radius.radiusFull};
`

export const TotalItemsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
  justify-content: space-between;
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.primary};
`

export const TotalItemsLabelContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
`
